import cookies from "./lib/cookies";

export interface IDataLayer {
    push: Function
}

const dataLayer = (window as any).dataLayer as IDataLayer;

cookies(dataLayer, (window as any).cookies);
if (dataLayer && 'gtag' in window) {
    cookies(dataLayer, (window as any).cookies);
}